import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { MediaModule } from 'src/layout/media/media.module';
import { NotificationOutletComponent } from './components/notification-outlet/notification-outlet.component';
import { NotificationModel } from './models/notification';
import { NOTIFICATION } from './tokens';



@NgModule({
  declarations: [
    NotificationOutletComponent
  ],
  imports: [
    CommonModule,
    MediaModule,
  ],
  exports: [NotificationOutletComponent],
  providers: [
    {
        provide: NOTIFICATION,
        useValue: new ReplaySubject<NotificationModel>(10)
    }
  ]
})
export class NotificationModule { }
